import { render, staticRenderFns } from "./MessageTemplatesEditDialog.vue?vue&type=template&id=95c1a04e&"
import script from "./MessageTemplatesEditDialog.vue?vue&type=script&lang=js&"
export * from "./MessageTemplatesEditDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports